import styled from 'styled-components';
import { getOverlayOpacity, getOverlayColor } from '../utils/loadingContainerHelpers';

export const ContainerWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  
  /* Se min-height for necessário, pode ser passado via prop */
  ${props => props.minHeight && `min-height: ${props.minHeight};`}
`;

export const OverlayLayer = styled.div`
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: ${props => getOverlayColor(props.theme)};
  opacity: ${props => getOverlayOpacity(props.opacity)};
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: inherit;
`;

export const LoadingContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/design-system/molecules/LoadingContainer/components/LoadingContainerStyles.js